module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cols2",
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "two"
  }, [_c('img', {
    staticStyle: {
      "transform": "rotate(3deg)"
    },
    attrs: {
      "src": require("../assets/media/ecriture.jpg")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(-2deg)"
    },
    attrs: {
      "src": require("../assets/media/vieux.jpg")
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "three",
    attrs: {
      "id": "timeline2"
    }
  }, [_c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tMay 2020 and beyond\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Traveling exhibition available")])])]), _vm._v(" "), _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tJune 2019 - March 2020\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Evian, France")])])]), _vm._v(" "), _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tJune 2017 - February 2018 \n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Musee des Confluences - Lyon, France")])])]), _vm._v(" "), _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tJuly 2016 - March 2017\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Bologna, Italy")])])]), _vm._v(" "), _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t2015\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Grand Palais - Paris, France")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ac88822","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/calendar.vue
// module id = 47
// module chunks = 0